<template>
  <v-data-table
    :headers="headersProcesados"
    :items="items"
    :footer-props="{
      itemsPerPageOptions: [10, 50, 100, -1],
    }"
  >
    <template v-slot:item.color="{ item }">
      <v-icon :color="item.color">circle</v-icon>
    </template>

    <template v-slot:item.opciones="{ item }">
      <v-icon
        color="blue"
        title="Editar parámetros compañía"
        class="mr-2"
        @click="$emit('editar-parametro', item)"
      >
        edit
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ParametrosGeneralesTable',

  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    mostrarOpciones: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Url para envíos de correos',
          value: 'url',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Nombre plataforma',
          value: 'nombrePlataforma',
          sortable: false,
          align: 'left',
        },
        { text: 'Color', value: 'color', sortable: false, align: 'center' },
      ],
    };
  },

  computed: {
    headersProcesados() {
      if (!this.mostrarOpciones) {
        return this.headers;
      }

      return [
        ...this.headers,
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ];
    },
  },

  methods: {},
};
</script>
